<template>
  <div class="yumnow">
    <div class="yumnow-main">
      <div class="yumnow-tips">
        <span v-if="isTips">{{ copyI18n.copySuccess }}</span>
      </div>

      <DownButton @click="clipboard" style="position relative;" class="yumnow-download-button">
        <img
          :src="downLoad.src"
          class="btn-logo display-middle"
        />
        <div
          class="position-center btn-font"
          v-text="copyI18n.downloadUrl"
        />
      </DownButton>
      <div class="copy-tips-content">{{ copyI18n.copyUrlTips }}</div>
    </div>
  </div>
</template>

<script>
import DownButton from "$downLoading/components/down-button";
import { clipboard } from '$common/utils/clipboard';
export default {
  props: {
    imgSrc: {
      type: String,
      default: () => ''
    },
    copyI18n: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: { DownButton },
  data() {
    return {
      isTips: false
    };
  },
  computed: {
    downLoad() {
      return {
        src: require('../../page/index/images/download-icon.png'),
        style: "width: 0.64rem;padding-top: 0.04rem;"
      };
    }
  },
  methods: {
    clipboard() {
      clipboard({
        copyString: `${window.location.origin}/mobile-h5/wownow/down-loading`,
        success: () => {
          this.isTips = true;
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .yumnow {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 300px;
    background:linear-gradient(to bottom, transparent, rgba(0,0,0,0.2), rgba(0,0,0,0.6))
  }
  .yumnow-main {
    width: 100%;
    height: 100%;
    position relative;
  }
  .yumnow-tips {
    width: fit-content;
    height: 34px;
    padding: 10px;
    background: rgba(0,0,0,0.702);
    text-align center;
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    color: #fff;
    opacity: 1;
    margin: 0 auto;
  }
  .btn-logo {
    width: 22px;
    position: absolute;
    top: 46%;
    left: 22px;
    transform: translate(0%, -50%);
  }
  .btn-font {
    font-size: 18px;
    font-family: Segoe UI;
    font-weight: 600;
    color: #fff;
    position: absolute;
    top: 50%;
    left: 55%;
    transform: translate(-50%, -50%);
  }
  .yumnow-download-button {
    margin-top: 138px;
  }
  .copy-tips-content {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #fff;
    opacity: 1;
    text-align: center;
    padding-top: 15px;
  }
</style>